import { initFaro, trackCtaClicked, trackRouteView } from './faro.js';
import { initHomepageNavigation, initDemoKeyboard, refreshCorpusStats, refreshHomepageAuth, homepageCtaId } from './homepageInteractions.js';

initFaro();
// The build stamps each imported page with its route; the homepage is the original.
const route = document.documentElement.dataset.routeTemplate || '/';
trackRouteView({ path: window.location.pathname, routeTemplate: route });
initHomepageNavigation();
initDemoKeyboard();
refreshCorpusStats();
// The server painted the state from the auth cookie; only a signed-in visitor has anything to confirm.
if (window.API_CONFIG.PUBLIC_AUTHENTICATED) refreshHomepageAuth();
window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshHomepageAuth();
});
document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshHomepageAuth();
});

document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const ctaId = homepageCtaId(link, window.API_CONFIG.APP_URL);
    if (ctaId) trackCtaClicked(ctaId);
});
